import * as ActionsTypes from '../constants/plugins/ActionTypes'

export const receivePlugins = (plugins) => ({
	type: ActionsTypes.RECEIVE_PLUGINS,
	plugins
})

export const changePlugin = (plugin) => ({
	type: ActionsTypes.CHANGE_PLUGIN,
	plugin
})
